<template>
  <div class="List">

    <ul class="List__sorting">
      <li 
        v-for="option in sortingBy" 
        :key="option.key" 
        @click="sortBy(option.key)">
        {{ option.label }}
      </li>
    </ul>

    <ul class="List__items" v-if="!isGrouped">
      <ListItem
        v-for="item in sortedItems"
        :key="item.slug"
        :to="item.to"
        :slug="item.slug"
        :name="item.name"
        :type="type"
        :readmore="readmore" />
    </ul>
    <template v-else>
      
      <template v-for="group in groupedAndSortedItems">
        <div :key="group.name">
          <SectionHeader :label="group.name" />
          <ul class="List__items">
            <ListItem
              v-for="item in group.items"
              :key="item.slug"
              :to="item.to"
              :slug="item.slug"
              :name="item.name"
              :type="type"
              :readmore="readmore" />
          </ul>
        </div>
      </template>

    </template>
  </div>
</template>

<script>

import dynamicSort from '@/helpers/dynamicSort';
import { capitalizeFirstLetter } from '@/helpers/string';

import SectionHeader from '@/components/section/Header';
import ListItem from '@/components/lists/ListItem';

export default {
  name: 'List',
  components: {
    SectionHeader,
    ListItem
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    sortingBy: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    groupBy: {
      type: Array,
      default: () => {
        return [];
      }
    },
    readmore: {
      type: String,
      default: 'Lees meer'
    }
  },
  data() {
    return {
      activeGroupedBy: null,
      activeSortingBy: null,
    }
  },
  computed: {
    sortedItems() {
      if (this.activeSortingBy !== null) {
        return this.items
          .slice()
          .sort(dynamicSort(this.activeSortingBy)); 
      }
      return [];
    },
    isGrouped() {
      return this.groupBy.length !== 0;
    },
    groupedAndSortedItems() {
      if (
        this.activeGroupedBy === null || 
        this.activeSortingBy === null
      ) {
        return [];
      }

      let groups = [];
      this.items
        .slice() // Make a copy to avoid modifying the original data
        .forEach((item) => {
          // Get the group value of the item
          let groupValue = item[this.activeGroupedBy] || null;

          // If a group value is found, go forward
          if (groupValue !== null) {
            groupValue = capitalizeFirstLetter(groupValue);

            // Check whether a group already exists 
            let group = null;
            groups.some((item, index) => {
              if (item.name === groupValue) {
                group = index;
                return true;
              }
            })
            // No matching group? Create a new one
            if (group === null) {
              groups.push({
                name: groupValue,
                items: [
                  item
                ]
              })
            } else {
              // Otherwise add the item to the list
              groups[group].items.push(item);
            }
          }
        });

      // Sort the items within the groups by the specified attribute
      let sortedGroups = [];
      groups.forEach((item) => {
        item = {
          name: item.name,
          items: item.items.sort(
            dynamicSort(this.activeSortingBy)
          )
        };
        sortedGroups.push(item)
      })

      // Sort the groups themselves by their group label
      return sortedGroups.sort(dynamicSort('name'));
    }
  },
  methods: {
    sortBy(key) {
      this.activeSortingBy = key;
    }

  },
  created() {
    this.activeSortingBy = this.sortingBy.length ? this.sortingBy[0].key : null;
    this.activeGroupedBy = this.groupBy.length ? this.groupBy[0].key : null;
  }
}
</script>

<style lang="scss">
  .List {
    display: flex;
    flex-direction: column;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    &__sorting {
      display: none;
      width: 100%;
    }

    ul.List__items {
      padding: 32px 0 16px 0;
    }

    .SectionHeader {
      padding-left: 24px;
      padding-right: 16px;
      padding-top: 16px;
      
      + ul {
        padding: 0;
      }
    }

  }
</style>
